import { render } from "./insure-company.vue?vue&type=template&id=724f6ac5&scoped=true&ts=true"
import script from "./insure-company.vue?vue&type=script&lang=ts"
export * from "./insure-company.vue?vue&type=script&lang=ts"

import "./insure-company.vue?vue&type=style&index=0&id=724f6ac5&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724f6ac5"]])

export default __exports__